import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ShapeService } from '../../shape/shape.service';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getProjectColorPalette } from '../../../projects/project.selector';
import { getCurrentOrgColorPalette } from '../../../organisation/organisation.selector';
import { map } from 'rxjs/operators';

export type ColorSelectorMode = 'default' | 'variable-save';

@Component({
  selector: 'nw-color-selector',
  templateUrl: './color-selector.component.html',
  styleUrls: ['./color-selector.component.scss'],
})
export class ColorSelectorComponent {
  @Input() label: string;

  @Input() color: string;
  @Input() isEnabled = true;
  @Output() colorChange = new EventEmitter<string>();

  @Input()
  dark: boolean;

  editActive = false;
  pristineColor: string;
  mode: ColorSelectorMode = 'default';
  projectColorPalette$: Observable<Array<{ label: string; color: string }>>;
  organizationColorPalette$: Observable<
    Array<{ label: string; color: string }>
  >;

  constructor(
    private shapeService: ShapeService,
    private readonly store: Store,
  ) {
    this.projectColorPalette$ = this.store.select(getProjectColorPalette).pipe(
      map(palette =>
        (palette || []).map(({ label, color }: any) => ({
          label,
          color: this.shapeService.resolveColor(color),
        })),
      ),
    );
    this.organizationColorPalette$ = this.store
      .select(getCurrentOrgColorPalette)
      .pipe(
        map((palette: Record<string, string>) =>
          Object.entries(palette || {})
            .filter(([label, color]) => !!color)
            .map(([label, color]) => ({
              label,
              color: this.shapeService.resolveColor(color),
            })),
        ),
      );
  }
  get resolvedColor() {
    return this.shapeService.resolveColor(this.color);
  }

  updateColor(color: string): void {
    this.color = color;
    this.colorChange.emit(color);
  }

  get colorLabel() {
    return this.color.startsWith('$') ? this.color.slice(2) : this.color;
  }

  saveAsVariable(): void {
    // TODO: Implement save as variable functionality
  }

  removeColor(): void {
    this.updateColor('');
  }

  dropDownClick() {
    // Handle dropdown click if needed
  }

  removeFill() {
    this.colorChange.emit(null);
  }

  saveVariable() {
    this.mode = 'variable-save';
  }
}
